/**
 * Extracts the domain and path from a URL string
 *
 * @param url URL string
 * @returns url domain and path
 */
export const extractURLDomainAndPath = (url: string) => {
  try {
    const parsedUrl = new URL(url)
    const domainAndPath = parsedUrl.origin + parsedUrl.pathname
    return domainAndPath
  } catch (e) {
    console.error(e)
  }
  return url
}
